import WorkshopAppBarItems from './WorkshopAppBarItems';

const AppbarModes = {
  WORKSHOP: WorkshopAppBarItems,
};

export default AppbarModes;
